export function getComponentPositionClass(position) {
    return {
        normal: 'component-position-normal',
        center: 'component-position-center',
        left: 'component-position-left',
        right: 'component-position-right',
        external: 'component-position-external',
        'external-left': 'component-position-external-left',
        'external-right': 'component-position-external-right',
    }[position];
}
export function getCssPropertyValue(property) {
    return getComputedStyle(document.documentElement).getPropertyValue(property).trim();
}
//# sourceMappingURL=components.js.map